var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    class: [{
      loaded: _vm.loaded
    }]
  }, [_c('loading-overlay', {
    attrs: {
      "tracking": {
        class: 'prequal',
        subclass: 'page'
      }
    },
    model: {
      value: _vm.loaded,
      callback: function ($$v) {
        _vm.loaded = $$v;
      },
      expression: "loaded"
    }
  }), _vm._v(" "), _c('section', {
    key: 'phone',
    staticClass: "section--phone"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('h2', {
    staticClass: "mt-0 mb-12 sm-md:mb-8 tracking-normal text-center sm-md:text-3xl lg:text-4xl"
  }, [_vm._v("\n\t\t\t\tLet’s get you set up with an Extra account\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-5"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.continueUrl
    },
    on: {
      "click": _vm.onContinueClick
    }
  }, [_c('button', {
    staticClass: "button--mint mt-10 px-16 sm:w-full",
    attrs: {
      "type": "submit",
      "disabled": _vm.processing
    }
  }, [_vm._v("\n\t\t\t\t\tCreate your account\n\t\t\t\t")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('disclosure-footer')], 1)])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "px-6 sm:px-0 md:px-6 max-w-xs"
  }, [_c('img', {
    staticClass: "w-full sm:max-w-xxs",
    attrs: {
      "src": require("assets/images/card-hand-credit-meter.jpg")
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "max-w-sm my-12"
  }, [_c('h5', {
    staticClass: "text-xl tracking-wide"
  }, [_vm._v("\n\t\t\t\t\tHere’s the next few actions you will need to take to create your account:\n\t\t\t\t")]), _vm._v(" "), _c('ul', {
    staticClass: "list-decimal pl-8 space-y-2 py-8"
  }, [_c('li', [_vm._v("Re-enter and verify your identity")]), _vm._v(" "), _c('li', [_vm._v("Connect your bank account via Plaid")]), _vm._v(" "), _c('li', [_vm._v("Activate your membership")])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tExtra will not collect membership via credit card and only via your linked bank accounts\n\t\t\t\t\tonce you have completed your application.\n\t\t\t\t")])]);
}];
export { render, staticRenderFns };